import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import axios from 'axios';

Vue.use(VueRouter);

import Login from '@/components/pages/Login.vue';
import Terms from '@/components/pages/Terms.vue';
import Base from '@/components/pages/common/Base.vue';
import Top from '@/components/pages/common/Top.vue';

import PasswordResetInput from '@/components/pages/password/PasswordResetInput.vue';
import PasswordModifyInput from '@/components/pages/password/PasswordModifyInput.vue';
import InitPasswordSettingInput from '@/components/pages/password/InitPasswordSettingInput.vue';

import CorporateBase from '@/components/pages/corporate/CorporateBase.vue';
import CorporateList from '@/components/pages/corporate/CorporateList.vue';
import CorporateCsv from '@/components/pages/corporate/CorporateCsv.vue';

import CorporateInput from '@/components/pages/corporate/CorporateInput.vue';
//import CorporateAccountMenu from '@/components/pages/corporate/CorporateAccountMenu.vue';
//import OfficeList from '@/components/pages/corporate/office/OfficeList.vue';
//import OfficeInput from '@/components/pages/corporate/office/OfficeInput.vue';
import UserInput from '@/components/pages/corporate/user/UserInput.vue';
import WorkplaceList from '@/components/pages/corporate/workplace/WorkplaceList.vue';

import DiagBase from '@/components/pages/diag/DiagBase.vue';
import DiagCourseSelect from '@/components/pages/diag/DiagCourseSelect.vue';
import DiagSectionList from '@/components/pages/diag/DiagSectionList.vue';
import DiagAnswerInput from '@/components/pages/diag/DiagAnswerInput.vue';
import OptionDiagAnswerInput from '@/components/pages/diag/OptionDiagAnswerInput.vue';
import DiagTop from '@/components/pages/diag/DiagTop.vue';
import DiagManagementList from '@/components/pages/diag/DiagManagementList.vue';
import DiagManagementDetail from '@/components/pages/diag/DiagManagementDetail.vue';
import TaskList from '@/components/pages/diag/TaskList.vue';
import TaskDetail from '@/components/pages/diag/TaskDetail.vue';

import RoughDiagBase from '@/components/pages/rough_diag/RoughDiagBase.vue';
import RoughDiagList from '@/components/pages/rough_diag/RoughDiagList.vue';
import RoughDiagAnswer from '@/components/pages/rough_diag/RoughDiagAnswer.vue';

import SolutionBase from '@/components/pages/solution/SolutionBase.vue';
import SolutionList from '@/components/pages/solution/SolutionList.vue';
import SolutionDetail from '@/components/pages/solution/SolutionDetail.vue';

import DocTop from '@/components/pages/doc/DocTop.vue';

// 人的資本関連
import HumanCapitalList from '@/components/pages/master/human_capital/HumanCapitalList.vue';

import HumanCapitalBase from '@/components/pages/human_capital/HumanCapitalBase.vue';
import HumanCapitalTop from '@/components/pages/human_capital/HumanCapitalTop.vue';
// 財務情報
import HumanCapitalFinancialInput from '@/components/pages/human_capital/HumanCapitalFinancialInput.vue';
import HumanCapitalFinancialReport from '@/components/pages/human_capital/HumanCapitalFinancialReport.vue';
// 採用女性労働者割合
import HumanCapitalFemalePercentageInput from '@/components/pages/human_capital/HumanCapitalFemalePercentageInput.vue';
import HumanCapitalFemalePercentageReport from '@/components/pages/human_capital/HumanCapitalFemalePercentageReport.vue';
// 平均継続勤務年数
import HumanCapitalEmploymentYearInput from '@/components/pages/human_capital/HumanCapitalEmploymentYearInput.vue';
import HumanCapitalEmploymentYearReport from '@/components/pages/human_capital/HumanCapitalEmploymentYearReport.vue';
// 離職率
import HumanCapitalTurnoverInput from '@/components/pages/human_capital/HumanCapitalTurnoverInput.vue';
import HumanCapitalTurnoverReport from '@/components/pages/human_capital/HumanCapitalTurnoverReport.vue';
// 女性管理職比率
import HumanCapitalFemaleManagerInput from '@/components/pages/human_capital/HumanCapitalFemaleManagerInput.vue';
import HumanCapitalFemaleManagerReport from '@/components/pages/human_capital/HumanCapitalFemaleManagerReport.vue';
// 平均年齢
import HumanCapitalAgeAverageInput from '@/components/pages/human_capital/HumanCapitalAgeAverageInput.vue';
import HumanCapitalAgeAverageReport from '@/components/pages/human_capital/HumanCapitalAgeAverageReport.vue';
// 障がい者雇用率
import HumanCapitalDisabilitiesRateInput from '@/components/pages/human_capital/HumanCapitalDisabilitiesRateInput.vue';
import HumanCapitalDisabilitiesRateReport from '@/components/pages/human_capital/HumanCapitalDisabilitiesRateReport.vue';
// 高年齢者雇用率
import HumanCapitalElderlyRateInput from '@/components/pages/human_capital/HumanCapitalElderlyRateInput.vue';
import HumanCapitalElderlyRateReport from '@/components/pages/human_capital/HumanCapitalElderlyRateReport.vue';
// 労災発生件数
import HumanCapitalAccidentsCountInput from '@/components/pages/human_capital/HumanCapitalAccidentsCountInput.vue';
import HumanCapitalAccidentsCountReport from '@/components/pages/human_capital/HumanCapitalAccidentsCountReport.vue';
// 年次有給休暇取得率
import HumanCapitalAcquisitionRateInput from '@/components/pages/human_capital/HumanCapitalAcquisitionRateInput.vue';
import HumanCapitalAcquisitionRateReport from '@/components/pages/human_capital/HumanCapitalAcquisitionRateReport.vue';
// 1月あたりの平均残業時間
import HumanCapitalWorkingAverageInput from '@/components/pages/human_capital/HumanCapitalWorkingAverageInput.vue';
import HumanCapitalWorkingAverageReport from '@/components/pages/human_capital/HumanCapitalWorkingAverageReport.vue';
// 育児休業取得率
import HumanCapitalChildcareRateInput from '@/components/pages/human_capital/HumanCapitalChildcareRateInput.vue';
import HumanCapitalChildcareRateReport from '@/components/pages/human_capital/HumanCapitalChildcareRateReport.vue';
// 介護休業・短時間勤務取得者数
import HumanCapitalNursingCareLeaveInput from '@/components/pages/human_capital/HumanCapitalNursingCareLeaveInput.vue';
import HumanCapitalNursingCareLeaveReport from '@/components/pages/human_capital/HumanCapitalNursingCareLeaveReport.vue';
// 年間平均賃金
import HumanCapitalWageAverageInput from '@/components/pages/human_capital/HumanCapitalWageAverageInput.vue';
import HumanCapitalWageAverageReport from '@/components/pages/human_capital/HumanCapitalWageAverageReport.vue';
// ５年間の推移グラフ
import HumanCapitalSummaryGraph from '@/components/pages/human_capital/HumanCapitalSummaryGraph.vue';

import MasterBase from '@/components/pages/master/MasterBase.vue';
import MasterTop from '@/components/pages/master/MasterTop.vue';
import DiagMasterList from '@/components/pages/master/diag/DiagMasterList.vue';
import DiagMasterEdit from '@/components/pages/master/diag/DiagMasterEdit.vue';
import DiagSectionMasterEdit from '@/components/pages/master/diag/DiagSectionMasterEdit.vue';

import DiagSectionMasterDeleteList from '@/components/pages/master/diag/DiagSectionMasterDeleteList.vue';

import DiagSubSectionMasterEdit from '@/components/pages/master/diag/DiagSubSectionMasterEdit.vue';
import DiagItemMasterEdit from '@/components/pages/master/diag/DiagItemMasterEdit.vue';
import DiagCourseList from '@/components/pages/master/diag_course/DiagCourseList.vue';
import DiagCourseInput from '@/components/pages/master/diag_course/DiagCourseInput.vue';
import RoughDiagMasterList from '@/components/pages/master/rough_diag/RoughDiagList.vue';
import RoughDiagMasterInput from '@/components/pages/master/rough_diag/RoughDiagInput.vue';
import SolutionMasterList from '@/components/pages/master/solution/SolutionMasterList.vue';
import SolutionMasterInput from '@/components/pages/master/solution/SolutionMasterInput.vue';
import GuideList from '@/components/pages/master/guide/GuideList.vue';

import NoticeBase from '@/components/pages/portal/notice/NoticeBase.vue';
import NoticeList from '@/components/pages/portal/notice/NoticeList.vue';
import NoticeInput from '@/components/pages/portal/notice/NoticeInput.vue';
import NoticeDetail from '@/components/pages/portal/notice/NoticeDetail.vue';

import InquiryBase from '@/components/pages/portal/inquiry/InquiryBase.vue';
import InquiryList from '@/components/pages/portal/inquiry/InquiryList.vue';
import InquiryInput from '@/components/pages/portal/inquiry/InquiryInput.vue';
import InquiryResInput from '@/components/pages/portal/inquiry/InquiryResInput.vue';
import InquiryDetail from '@/components/pages/portal/inquiry/InquiryDetail.vue';

import ContactFormBase from '@/components/pages/contact_form/ContactFormBase.vue';
import ContactForm from '@/components/pages/contact_form/ContactForm.vue';
import ContactFormConfirm from '@/components/pages/contact_form/ContactFormConfirm.vue';
import ContactFormComplete from '@/components/pages/contact_form/ContactFormComplete.vue';
import MailAddressConfirm from '@/components/pages/contact_form/MailAddressConfirm.vue';

import TrialEntryList from '@/components/pages/trial/TrialEntryList.vue';
import TrialEntryConfirm from '@/components/pages/trial/TrialEntryConfirm.vue';

//import Judge from '@/components/pages/common/diag/Judge.vue';


const router = new VueRouter({
  mode: 'history',
  relative: true,
  base: '/ld',
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    { name: 'login', path: '/', component: Login, meta: { requiresAuth: false, isDisplayBrowserBackAlert: false , isUseMemo: false } },
    { name: 'terms', path: '/terms', component: Terms, meta: { requiresAuth: false, isDisplayBrowserBackAlert: false, title: '利用規約', isUseMemo: false } },
    { name: 'password-reset-input', path: '/password_reset', component: PasswordResetInput, meta: { requiresAuth: false, isDisplayBrowserBackAlert: false, isUseMemo: false } },
    { name: 'password-modify-input', path: '/password_modify', component: PasswordModifyInput, meta: { requiresAuth: false, isDisplayBrowserBackAlert: false, isUseMemo: false } },
    { name: 'init-password-setting', path: '/init_password_setting', component: InitPasswordSettingInput, meta: { requiresAuth: false, isDisplayBrowserBackAlert: false, isUseMemo: false } },
    {
      path: '/top',
      component: Base,
      children: [
        // トップ
        { name: 'top', path: '/top', component: Top, meta: { requiresAuth: true, isDisplayBrowserBackAlert: false, isUseMemo: true } },
        // 法人・ユーザ情報
        {
          path: '/corporate',
          component: CorporateBase,
          children: [
            { name: 'corporate-new', path: 'new', component: CorporateInput, meta: { requiresAuth: true, globalMenuName: 'corporate', isDisplayBrowserBackAlert: false, title: '法人情報', isAccountEdit: false, isUseMemo: false } },
            { name: 'corporate-csv', path: 'csv', component: CorporateCsv,  meta: { requiresAuth: true, globalMenuName: 'corporate', isDisplayBrowserBackAlert: false, title: '法人情報', isAccountEdit: false, isUseMemo: false } },
            { name: 'corporate-edit', path: 'edit', component: CorporateInput, meta: { requiresAuth: true, globalMenuName: 'corporate', isDisplayBrowserBackAlert: false, title: '法人情報', isAccountEdit: false, isUseMemo: false } },
            // 事業所は不要
            //{ name: 'office-list', path: 'office/list', component: OfficeList, meta: { requiresAuth: true } },
            //{ name: 'office-new', path: 'office/edit', component: OfficeInput, meta: { requiresAuth: true } },
            //{ name: 'office-edit', path: 'office/edit', component: OfficeInput, meta: { requiresAuth: true } },
            { name: 'workplace-list', path: 'workplace/list', component: WorkplaceList, meta: { requiresAuth: true, globalMenuName: 'corporate', isDisplayBrowserBackAlert: false, title: '法人情報', isAccountEdit: false, isUseMemo: false } },
            { name: 'user-new', path: 'user/new', component: UserInput, meta: { requiresAuth: true, globalMenuName: 'corporate', isDisplayBrowserBackAlert: false, title: '法人情報', isAccountEdit: false, isUseMemo: false } },
            { name: 'user-edit', path: 'user/edit', component: UserInput, meta: { requiresAuth: true, globalMenuName: 'corporate', isDisplayBrowserBackAlert: false, title: '法人情報', isAccountEdit: false, isUseMemo: false } },
            //{ name: 'corporate-account-menu', path: 'me', component: CorporateAccountMenu, meta: { requiresAuth: true, globalMenuName: 'corporate' } },
            { name: 'corporate-list', path: 'list', component: CorporateList, meta: { requiresAuth: true, globalMenuName: 'corporate', isDisplayBrowserBackAlert: false, title: '法人情報', isAccountEdit: false, isUseMemo: false } },
          ]
        },
        { name: 'account-edit', path: '/account/edit', component: CorporateInput, meta: { requiresAuth: true, globalMenuName: '', isDisplayBrowserBackAlert: false, title: 'アカウント情報', isAccountEdit: true, isUseMemo: true } },
        { name: 'account-user-new', path: '/account/user/new', component: UserInput, meta: { requiresAuth: true, globalMenuName: '', isDisplayBrowserBackAlert: false, title: 'アカウント情報', isAccountEdit: true, isUseMemo: true } },
        { name: 'account-user-edit', path: '/account/user/edit', component: UserInput, meta: { requiresAuth: true, globalMenuName: '', isDisplayBrowserBackAlert: false, title: 'アカウント情報', isAccountEdit: true, isUseMemo: true } },
        { name: 'account-workplace-list', path: '/account/workplace/list', component: WorkplaceList, meta: { requiresAuth: true, globalMenuName: '', isDisplayBrowserBackAlert: false, title: 'アカウント情報', isAccountEdit: true, isUseMemo: true } },

        // 診断
        {
          path: '/diag',
          component: DiagBase,
          children: [
            { name: 'diag-course-select', path: 'course_select', component: DiagCourseSelect, meta: { requiresAuth: true, globalMenuName: 'diag', isDisplayBrowserBackAlert: false, title: '監査', isUseMemo: true } },
            { name: 'diag-top', path: 'top', component: DiagTop, meta: { requiresAuth: true, globalMenuName: 'diag', isDisplayBrowserBackAlert: false, title: '監査', isUseMemo: true } },
            { name: 'diag-section-list', path: 'sectionList', component: DiagSectionList, meta: { requiresAuth: true, globalMenuName: 'diag', isDisplayBrowserBackAlert: false, title: '監査', isUseMemo: true } },
            { name: 'diag-answer-input', path: '/diag/input', component: DiagAnswerInput, meta: { requiresAuth: true, globalMenuName: 'diag', isDisplayBrowserBackAlert: true, title: '監査', isUseMemo: true } },
            { name: 'option-diag-answer-input', path: '/option-diag/input', component: OptionDiagAnswerInput, meta: { requiresAuth: true, globalMenuName: 'diag', isDisplayBrowserBackAlert: true, title: '監査', isUseMemo: true } },
            { name: 'diag-management-list', path: 'management/list', component: DiagManagementList, meta: { requiresAuth: true, globalMenuName: 'diag', isDisplayBrowserBackAlert: false, title: '監査', isUseMemo: true } },
            { name: 'diag-management-detail', path: 'management/detail', component: DiagManagementDetail, meta: { requiresAuth: true, globalMenuName: 'diag', isDisplayBrowserBackAlert: true, title: '監査', isUseMemo: true } },
            { name: 'task-list', path: 'task/list', component: TaskList, meta: { requiresAuth: true, globalMenuName: 'diag', isDisplayBrowserBackAlert: false, title: '監査', isUseMemo: true } },
            { name: 'task-detail', path: 'task/detail', component: TaskDetail, meta: { requiresAuth: true, globalMenuName: 'diag', isDisplayBrowserBackAlert: true, title: '監査', isUseMemo: true } },
          ]
        },
   
        // 小診断
        {
          path: '/rough_diag',
          component: RoughDiagBase,
          children: [
            { name: 'rough-diag-list', path: 'list', component: RoughDiagList, meta: { requiresAuth: true, globalMenuName: 'rough-diag', isDisplayBrowserBackAlert: false, title: '小テスト', isUseMemo: true } },
            { name: 'rough-diag-answer', path: 'answer', component: RoughDiagAnswer, meta: { requiresAuth: true, globalMenuName: 'rough-diag', isDisplayBrowserBackAlert: true, title: '小テスト', isUseMemo: true } },
          ]
        },

        // 書式
        {
          path: '/doc',
          name: 'doc-list',
          component: DocTop,
          meta: { requiresAuth: true, globalMenuName: 'document', isDisplayBrowserBackAlert: false, title: '書式', isUseMemo: true },
        },

        // 診断マスタ
        {
          path: '/master',
          component: MasterBase,
          children: [
            { name: 'master-top', path: 'top', component: MasterTop, meta: { requiresAuth: true, globalMenuName: 'diag-master', isDisplayBrowserBackAlert: false, isUseMemo: false } },
            { name: 'diag-master-list', path: 'diag/list', component: DiagMasterList, meta: { requiresAuth: true, globalMenuName: 'diag-master', isDisplayBrowserBackAlert: false, isUseMemo: false } },
            { name: 'diag-master-edit', path: 'diag/edit', component: DiagMasterEdit, meta: { requiresAuth: true, globalMenuName: 'diag-master', isDisplayBrowserBackAlert: false, isUseMemo: false } },
            { name: 'diag-section-master-edit', path: 'diag/section/edit', component: DiagSectionMasterEdit, meta: { requiresAuth: true, globalMenuName: 'diag-master', isDisplayBrowserBackAlert: false, isUseMemo: false } },
            { name: 'diag-section-master-new', path: 'diag/section/new', component: DiagSectionMasterEdit, meta: { requiresAuth: true, globalMenuName: 'diag-master', isDisplayBrowserBackAlert: false, isUseMemo: false } },
            { name: 'diage-section-master-delete-list', path: 'diag/section/delete_list', component: DiagSectionMasterDeleteList, meta: { requiresAuth: true, globalMenuName: 'diag-master', isDisplayBrowserBackAlert: false, isUseMemo: false } },
            { name: 'diag-sub-section-master-edit', path: 'diag/sub_section/edit', component: DiagSubSectionMasterEdit, meta: { requiresAuth: true, globalMenuName: 'diag-master', isDisplayBrowserBackAlert: false, isUseMemo: false } },
            { name: 'diag-sub-section-master-new', path: 'diag/sub_section/new', component: DiagSubSectionMasterEdit, meta: { requiresAuth: true, globalMenuName: 'diag-master', isDisplayBrowserBackAlert: false, isUseMemo: false } },
            { name: 'diag-item-master-edit', path: 'diag/item/edit', component: DiagItemMasterEdit, meta: { requiresAuth: true, globalMenuName: 'diag-master', isDisplayBrowserBackAlert: false, isUseMemo: false } },
            { name: 'diag-item-master-new', path: 'diag/item/new', component: DiagItemMasterEdit, meta: { requiresAuth: true, globalMenuName: 'diag-master', isDisplayBrowserBackAlert: false, isUseMemo: false } },
            { name: 'diag-course-list', path: 'diag_course', component: DiagCourseList, meta: { requiresAuth: true, globalMenuName: 'diag-master', isDisplayBrowserBackAlert: false, isUseMemo: false } },
            { name: 'diag-course-new', path: 'diag_course/new', component: DiagCourseInput, meta: { requiresAuth: true, globalMenuName: 'diag-master', isDisplayBrowserBackAlert: false, isUseMemo: false } },
            { name: 'diag-course-edit', path: 'diag_course/edit', component: DiagCourseInput, meta: { requiresAuth: true, globalMenuName: 'diag-master', isDisplayBrowserBackAlert: false, isUseMemo: false } },
            { name: 'rough-diag-master-list', path: 'rough_diag', component: RoughDiagMasterList, meta: { requiresAuth: true, globalMenuName: 'diag-master', isDisplayBrowserBackAlert: false, isUseMemo: false } },
            { name: 'rough-diag-master-new', path: 'rough_diag/new', component: RoughDiagMasterInput, meta: { requiresAuth: true, globalMenuName: 'diag-master', isDisplayBrowserBackAlert: false, isUseMemo: false } },
            { name: 'rough-diag-master-edit', path: 'rough_diag/edit', component: RoughDiagMasterInput, meta: { requiresAuth: true, globalMenuName: 'diag-master', isDisplayBrowserBackAlert: false, isUseMemo: false } },
            { name: 'solution-master-list', path: 'solution', component: SolutionMasterList, meta: { requiresAuth: true, globalMenuName: 'solution-master', isDisplayBrowserBackAlert: false, isUseMemo: false } },
            { name: 'solution-master-new', path: 'solution/new', component: SolutionMasterInput, meta: { requiresAuth: true, globalMenuName: 'solution-master', isDisplayBrowserBackAlert: false, isUseMemo: false } },
            { name: 'solution-master-edit', path: 'solution/edit', component: SolutionMasterInput, meta: { requiresAuth: true, globalMenuName: 'solution-master', isDisplayBrowserBackAlert: false, isUseMemo: false } },
            // ガイド
            { name: 'guide-list', path: 'guide/list', component: GuideList, meta: { requiresAuth: true, globalMenuName: 'guide', isDisplayBrowserBackAlert: false, isUseMemo: false } },
            // 人的資本管理
            { name: 'human-capital-list', path: 'human_capital/list', component: HumanCapitalList, meta: { requiresAuth: true, globalMenuName: 'human-capital', isDisplayBrowserBackAlert: true, isUseMemo: false } },
          ]
        },
        // お知らせ
        {
          path: '/notice',
          component: NoticeBase,
          children: [
            { name: 'notice-list', path: 'list', component: NoticeList, meta: { requiresAuth: true, globalMenuName: 'notice', isDisplayBrowserBackAlert: false, title: 'お知らせ', isUseMemo: true } },
            { name: 'notice-new', path: 'new', component: NoticeInput, meta: { requiresAuth: true, globalMenuName: 'notice', isDisplayBrowserBackAlert: false, title: 'お知らせ', isUseMemo: true } },
            { name: 'notice-edit', path: 'edit', component: NoticeInput, meta: { requiresAuth: true, globalMenuName: 'notice', isDisplayBrowserBackAlert: false, title: 'お知らせ', isUseMemo: true } },
            { name: 'notice-detail', path: 'detail', component: NoticeDetail, meta: { requiresAuth: true, globalMenuName: 'notice', isDisplayBrowserBackAlert: false, title: 'お知らせ', isUseMemo: true } },
          ]
        },

        // お問い合わせ
        {
          path: '/inquiry',
          component: InquiryBase,
          children: [
            { name: 'inquiry-list', path: 'list', component: InquiryList, meta: { requiresAuth: true, globalMenuName: 'inquiry', isDisplayBrowserBackAlert: false, title: 'お問い合わせ', isUseMemo: true } },
            { name: 'inquiry-new', path: 'new', component: InquiryInput, meta: { requiresAuth: true, globalMenuName: 'inquiry', isDisplayBrowserBackAlert: false, title: 'お問い合わせ', isUseMemo: true } },
            { name: 'inquiry-res', path: 'res', component: InquiryResInput, meta: { requiresAuth: true, globalMenuName: 'inquiry', isDisplayBrowserBackAlert: false, title: 'お問い合わせ', isUseMemo: true } },
            { name: 'inquiry-detail', path: 'detail', component: InquiryDetail, meta: { requiresAuth: true, globalMenuName: 'inquiry', isDisplayBrowserBackAlert: false, title: 'お問い合わせ', isUseMemo: true } },
          ]
        },

        // ソリューション
        {
          path: '/solution',
          component: SolutionBase,
          children: [
            { name: 'solution-list', path: 'list', component: SolutionList, meta: { requiresAuth: true, globalMenuName: 'solution', isDisplayBrowserBackAlert: false, title: 'ソリューション', isUseMemo: true } },
            { name: 'solution-detail', path: 'detail', component: SolutionDetail, meta: { requiresAuth: true, globalMenuName: 'solution', isDisplayBrowserBackAlert: false, title: 'ソリューション', isUseMemo: true } },
          ]
        },

        // トライアル申込一覧
        { name: 'trial-entry-list', path: '/trial_entry/list', component: TrialEntryList, meta: { requiresAuth: true, globalMenuName: 'trial-entry', isDisplayBrowserBackAlert: false, isUseMemo: false } },
        { name: 'trial-entry-confirm', path: '/trial_entry/confirm', component: TrialEntryConfirm, meta: { requiresAuth: true, globalMenuName: 'trial-entry', isDisplayBrowserBackAlert: false, isUseMemo: false } },

        // パラメータアクセス版
        // 診断
        {
          path: '/diag/:corpId/:diagResultId/',
          component: DiagBase,
          children: [
            { name: 'diag-top', path: 'topparam', component: DiagTop, meta: { requiresAuth: true, globalMenuName: 'diag', isDisplayBrowserBackAlert: false, title: '監査', canRedirect: true, isUseMemo: true } },
          ]
        },
        // 診断
        {
          path: '/diag/task/:corpId/:diagResultId/:diagResultItemId/',
          component: DiagBase,
          children: [
            { name: 'task-detail', path: 'task/detailparam', component: TaskDetail, meta: { requiresAuth: true, globalMenuName: 'diag', isDisplayBrowserBackAlert: true, title: '監査', canRedirect: true, isUseMemo: true } },
          ]
        },
        // 診断
        {
          path: '/diag/management/:corpId/:diagResultId/:diagResultItemId/',
          component: DiagBase,
          children: [
            { name: 'diag-management-detail', path: 'management/detailparam', component: DiagManagementDetail, meta: { requiresAuth: true, globalMenuName: 'diag', isDisplayBrowserBackAlert: true, title: '監査', canRedirect: true, isUseMemo: true } },
          ]
        },
        // 小診断
        {
          path: '/rough_diag/:corpId/:roughDiagId/',
          component: RoughDiagBase,
          children: [
            { name: 'rough-diag-answer', path: 'answerparam', component: RoughDiagAnswer, meta: { requiresAuth: true, globalMenuName: 'rough-diag', isDisplayBrowserBackAlert: true, title: '小テスト', canRedirect: true, isUseMemo: true } },
          ]
        },

        // 人的資本
        {
          path: '/hr/:corpId/',
          component: HumanCapitalBase,
          children: [
            { name: 'hr-top', path: 'topparam', component: HumanCapitalTop, meta: { requiresAuth: true, globalMenuName: 'hr', isDisplayBrowserBackAlert: false, title: '人的資本管理', canRedirect: true, isUseMemo: true } },
            // 財務情報
            { name: 'hr-financial-input',  path: 'financial_input', component: HumanCapitalFinancialInput, meta: { requiresAuth: true, globalMenuName: 'hr', isDisplayBrowserBackAlert: false, title: '人的資本', canRedirect: true, isUseMemo: true } },
            { name: 'hr-financial-report', path: 'financial_report', component: HumanCapitalFinancialReport, meta: { requiresAuth: true, globalMenuName: 'hr', isDisplayBrowserBackAlert: false, title: '人的資本', canRedirect: true, isUseMemo: true } },
            // 採用女性割合
            { name: 'hr-female-percentage-input',  path: 'female_percentage_input', component: HumanCapitalFemalePercentageInput, meta: { requiresAuth: true, globalMenuName: 'hr', isDisplayBrowserBackAlert: false, title: '人的資本', canRedirect: true, isUseMemo: true } },
            { name: 'hr-female-percentage-report', path: 'female_percentage_report', component: HumanCapitalFemalePercentageReport, meta: { requiresAuth: true, globalMenuName: 'hr', isDisplayBrowserBackAlert: false, title: '人的資本', canRedirect: true, isUseMemo: true } },
            // 平均勤続年数
            { name: 'hr-employment-year-input',  path: 'employment_year_input', component: HumanCapitalEmploymentYearInput, meta: { requiresAuth: true, globalMenuName: 'hr', isDisplayBrowserBackAlert: false, title: '人的資本', canRedirect: true, isUseMemo: true } },
            { name: 'hr-employment-year-report', path: 'employment_year_report', component: HumanCapitalEmploymentYearReport, meta: { requiresAuth: true, globalMenuName: 'hr', isDisplayBrowserBackAlert: false, title: '人的資本', canRedirect: true, isUseMemo: true } },
            // 離職率
            { name: 'hr-turnover-input',  path: 'turnover_input', component: HumanCapitalTurnoverInput, meta: { requiresAuth: true, globalMenuName: 'hr', isDisplayBrowserBackAlert: false, title: '人的資本', canRedirect: true, isUseMemo: true } },
            { name: 'hr-turnover-report', path: 'turnover_report', component: HumanCapitalTurnoverReport, meta: { requiresAuth: true, globalMenuName: 'hr', isDisplayBrowserBackAlert: false, title: '人的資本', canRedirect: true, isUseMemo: true } },
            // 女性管理職比率
            { name: 'hr-female-manager-input',  path: 'female_manager_input', component: HumanCapitalFemaleManagerInput, meta: { requiresAuth: true, globalMenuName: 'hr', isDisplayBrowserBackAlert: false, title: '人的資本', canRedirect: true, isUseMemo: true } },
            { name: 'hr-female-manager-report', path: 'female_manager_report', component: HumanCapitalFemaleManagerReport, meta: { requiresAuth: true, globalMenuName: 'hr', isDisplayBrowserBackAlert: false, title: '人的資本', canRedirect: true, isUseMemo: true } },
            // 平均年齢
            { name: 'hr-age-average-input',  path: 'age_average_input', component: HumanCapitalAgeAverageInput, meta: { requiresAuth: true, globalMenuName: 'hr', isDisplayBrowserBackAlert: false, title: '人的資本', canRedirect: true, isUseMemo: true } },
            { name: 'hr-age-average-report', path: 'age_average_report', component: HumanCapitalAgeAverageReport, meta: { requiresAuth: true, globalMenuName: 'hr', isDisplayBrowserBackAlert: false, title: '人的資本', canRedirect: true, isUseMemo: true } },
            // 障がい者雇用率
            { name: 'hr-disabilities-rate-input',  path: 'disabilities_rate_input', component: HumanCapitalDisabilitiesRateInput, meta: { requiresAuth: true, globalMenuName: 'hr', isDisplayBrowserBackAlert: false, title: '人的資本', canRedirect: true, isUseMemo: true } },
            { name: 'hr-disabilities-rate-report', path: 'disabilities_rate_report', component: HumanCapitalDisabilitiesRateReport, meta: { requiresAuth: true, globalMenuName: 'hr', isDisplayBrowserBackAlert: false, title: '人的資本', canRedirect: true, isUseMemo: true } },
            // 高年齢者雇用率
            { name: 'hr-elderly-rate-input',  path: 'elderly_rate_input', component: HumanCapitalElderlyRateInput, meta: { requiresAuth: true, globalMenuName: 'hr', isDisplayBrowserBackAlert: false, title: '人的資本', canRedirect: true, isUseMemo: true } },
            { name: 'hr-elderly-rate-report', path: 'elderly_rate_report', component: HumanCapitalElderlyRateReport, meta: { requiresAuth: true, globalMenuName: 'hr', isDisplayBrowserBackAlert: false, title: '人的資本', canRedirect: true, isUseMemo: true } },
            // 労災発生件数
            { name: 'hr-accidents-count-input',  path: 'accidents_count_input', component: HumanCapitalAccidentsCountInput, meta: { requiresAuth: true, globalMenuName: 'hr', isDisplayBrowserBackAlert: false, title: '人的資本', canRedirect: true, isUseMemo: true } },
            { name: 'hr-accidents-count-report', path: 'accidents_count_report', component: HumanCapitalAccidentsCountReport, meta: { requiresAuth: true, globalMenuName: 'hr', isDisplayBrowserBackAlert: false, title: '人的資本', canRedirect: true, isUseMemo: true } },
            // 年次有給休暇取得率
            { name: 'hr-acquisition-rate-input',  path: 'acquisition_rate_input', component: HumanCapitalAcquisitionRateInput, meta: { requiresAuth: true, globalMenuName: 'hr', isDisplayBrowserBackAlert: false, title: '人的資本', canRedirect: true, isUseMemo: true } },
            { name: 'hr-acquisition-rate-report', path: 'acquisition_rate_report', component: HumanCapitalAcquisitionRateReport, meta: { requiresAuth: true, globalMenuName: 'hr', isDisplayBrowserBackAlert: false, title: '人的資本', canRedirect: true, isUseMemo: true } },
            // 1月あたりの平均残業時間
            { name: 'hr-working-average-input',  path: 'working_average_input', component: HumanCapitalWorkingAverageInput, meta: { requiresAuth: true, globalMenuName: 'hr', isDisplayBrowserBackAlert: false, title: '人的資本', canRedirect: true, isUseMemo: true } },
            { name: 'hr-working-average-report', path: 'working_average_report', component: HumanCapitalWorkingAverageReport, meta: { requiresAuth: true, globalMenuName: 'hr', isDisplayBrowserBackAlert: false, title: '人的資本', canRedirect: true, isUseMemo: true } },
            // 育児休業取得率
            { name: 'hr-childcare-rate-input',  path: 'childcare_rate_input', component: HumanCapitalChildcareRateInput, meta: { requiresAuth: true, globalMenuName: 'hr', isDisplayBrowserBackAlert: false, title: '人的資本', canRedirect: true, isUseMemo: true } },
            { name: 'hr-childcare-rate-report', path: 'childcare_rate_report', component: HumanCapitalChildcareRateReport, meta: { requiresAuth: true, globalMenuName: 'hr', isDisplayBrowserBackAlert: false, title: '人的資本', canRedirect: true, isUseMemo: true } },
            // 介護休業・短時間勤務取得者数
            { name: 'hr-nursing-care-input',  path: 'nursing_care_input', component: HumanCapitalNursingCareLeaveInput, meta: { requiresAuth: true, globalMenuName: 'hr', isDisplayBrowserBackAlert: false, title: '人的資本', canRedirect: true, isUseMemo: true } },
            { name: 'hr-nursing-care-report', path: 'nursing_care_report', component: HumanCapitalNursingCareLeaveReport, meta: { requiresAuth: true, globalMenuName: 'hr', isDisplayBrowserBackAlert: false, title: '人的資本', canRedirect: true, isUseMemo: true } },
            // 年間平均賃金
            { name: 'hr-wage-average-input',  path: 'wage_average_input', component: HumanCapitalWageAverageInput, meta: { requiresAuth: true, globalMenuName: 'hr', isDisplayBrowserBackAlert: false, title: '人的資本', canRedirect: true, isUseMemo: true } },
            { name: 'hr-wage-average-report', path: 'wage_average_report', component: HumanCapitalWageAverageReport, meta: { requiresAuth: true, globalMenuName: 'hr', isDisplayBrowserBackAlert: false, title: '人的資本', canRedirect: true, isUseMemo: true } },
            // ５年間の推移グラフ
            { name: 'hr-summary-graph',  path: 'summary_graph', component: HumanCapitalSummaryGraph, meta: { requiresAuth: true, globalMenuName: 'hr', isDisplayBrowserBackAlert: false, title: '人的資本', canRedirect: true, isUseMemo: true } },
          ]
        },
      ],
    },

    // 一般問合せフォーム
    {
      path: '/contact',
      component: ContactFormBase,
      children: [
        { name: 'contact-form-input', path: 'form', component: ContactForm, meta: { requiresAuth: false, isDisplayBrowserBackAlert: false, title: 'トライアル申し込み', isUseMemo: false } },
        { name: 'contact-form-confirm', path: 'confirm', component: ContactFormConfirm, meta: { requiresAuth: false }, isDisplayBrowserBackAlert: false, title: 'トライアル申し込み', isUseMemo: false },
        { name: 'contact-form-complete', path: 'complete', component: ContactFormComplete, meta: { requiresAuth: false, isDisplayBrowserBackAlert: false, title: 'トライアル申し込み', isUseMemo: false } },
        { name: 'contact-form-mail-address-confirm', path: 'mail_address_confirm', component: MailAddressConfirm, meta: { requiresAuth: false, isDisplayBrowserBackAlert: false, title: 'トライアル申し込み', isUseMemo: false } },
      ]
    },

  ],
});

const DEFAULT_TITLE = '労務監査クラウド';
document.title = DEFAULT_TITLE;

Vue.prototype.$disableBackBrowser = false;
addEventListener("popstate", () => {
  Vue.prototype.$disableBackBrowser = true;
});

async function checkPermission(routeName) {
  const res = await axios.post('/ld/api/auth/checkAccessPermission', {
    routeName: routeName,
  });
  if (res) {
    return res.data.accessible;
  }
  return false;
}

router.beforeEach((to, from, next) => {
  document.title = (to.meta.title)
    ? to.meta.title + ' | ' + DEFAULT_TITLE
    : DEFAULT_TITLE;
  if (Vue.prototype.$disableBackBrowser) {
    Vue.prototype.$disableBackBrowser = false;
    if (from.matched.some(record => record.meta.isDisplayBrowserBackAlert)) {
      const answer = window.confirm("編集中のものは保存されませんが、よろしいですか？");
      if (!answer) {
        return false;
      }
    }
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters['auth/isLogin'] === false) {
      if ( to.matched.some(record => record.meta.canRedirect) ){
        next({
          path: '/',
          query: { redirect: to.fullPath }
        })
        return;
      }else{
        next({
          path: '/',
        })
        return;
      }
    }
    if (!to.query.usertype) {
      const user = store.getters["auth/getUser"];
      if (user.userAuthTypeText) {
        let query = to.query;
        query.usertype = user.userAuthTypeText;
        router.push({ path: to.path, params: to.params, query: query, hash: to.hash }).catch(err => { }); // eslint-disable-line
        return;
      }
    }
  }
  next();
});

router.afterEach(async (to) => {
/* redirect対応
console.log(store.getters['auth/getLastAccessUrl']);
*/
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters['auth/isLogin']) {
      const isAccessible = await checkPermission(to.name);
      if (!isAccessible) {
        store.dispatch('auth/forbiddenAccess');
      }
    }
  }
});

export default router;
